import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { PrestationModalService } from 'src/app/trip-calculator/services/prestation-modal.service';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-prestation-type-selector',
  imports: [ButtonModule, TranslocoPipe, LucideAngularModule],
  templateUrl: './prestation-type-selector.component.html',
})
export class PrestationTypeSelectorComponent {
  prestationModalService = inject(PrestationModalService);
}
